import { Helmet } from "react-helmet-async";

const SITE_URL = "https://knovas.in";
const DEFAULT_IMAGE = `${SITE_URL}/og-cover.jpg`;

/**
 * Per-page SEO tags: title, meta description, canonical + Open Graph / Twitter.
 * Pass `path` (e.g. "/catalogue") to build the canonical + og:url.
 */
export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd = null }) {
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="KNOVAS" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
